import { APP_CONFIG } from 'core';
import config from 'config';
import Logo from './Logo.styles';
import type { LogoProps } from './Logo.d';

const { [APP_CONFIG.short]: brandSVGPath, vdf: brandSVGPathVDF } = require('./Logo.data');

const LogoBase = ({
  brand = 'eud',
  color,
  type = 'default',
  isMultiBrand = false,
  ...props
}: LogoProps) => {
  const { paths, viewBox } =
    isMultiBrand && brand !== 'vdi' ? brandSVGPathVDF[type] : brandSVGPath[type];
  const labelLogo = isMultiBrand
    ? `logo dos ${config.communication.userNamingConvention.plural} grupo ${config.app.name}`
    : `logo ${config.communication.userNamingConvention.singular} ${config.app.name}`;

  return (
    <Logo
      aria-label={labelLogo}
      data-color={color}
      data-testid={`logo-${brand}`}
      data-brand={brand}
      data-multibrand={isMultiBrand}
      preserveAspectRatio="xMidYMid meet"
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {paths.map((path: string, index: number) => (
        <path key={`${type}-${index}`} d={path} fillRule="evenodd" />
      ))}
    </Logo>
  );
};

export default LogoBase;
